import React from 'react'
import styled from "@emotion/styled"
import { Link } from "gatsby"
import Ball from "./ball.png"
import SideBar from "./sidebar"
import "./menu.css"


const NavbarContainer = styled.nav`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #faf2f0;
  font-size: 1.4rem;
  z-index: 999;
`

const NavWrap = styled.div`
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 5.4rem;
  color: #0c0c0c;
`
const Title = styled.a`
  font-family: Windsor;
  font-size: 2rem;
  z-index: 2;
  color: #100504;
  padding: 2rem;
  margin: 0;
  width: 50%;
  text-decoration: none;

  & span {
    color: #d6756c;
    -webkit-text-stroke: 0;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding-top: 1rem;
  }

  @media (max-width: 425px) {
    font-size: 1.75rem;
    padding: 1rem;
    line-height: 1.75rem;
    margin-top: 0.25rem;
    margin-left: 0.25rem;
  }
`

const NavLinks = styled.ul`
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  list-style-type: none;
  margin: 0;
  margin-right: 1rem;
  width: 50%;

  & a {
    color: #100504;
    font-family: "Windsor";
    font-size: 1.5rem;
    margin: 0 1rem;
    text-decoration: none;
    cursor: pointer;
    position: relative;

    &:after {
      background: none repeat scroll 0 0 transparent;
      bottom: 0;
      content: "";
      display: block;
      height: 3px;
      left: 50%;
      position: absolute;
      background: #d6756c;
      -webkit-transition: width 0.3s ease 0s, left 0.3s ease 0s;
      -o-transition: width 0.3s ease 0s, left 0.3s ease 0s;
      transition: width 0.3s ease 0s, left 0.3s ease 0s;
      width: 0;
    }

    &:hover:after {
      width: 100%; 
      left: 0;
    }

    @media (max-width: 1200px) {
      display: none;
    }
  }
`;

const NavBallImg = styled.img`
  width: 50px;
  height: 50px;
  margin-bottom: -0.5rem;

  @media (max-width: 425px) {
    width: 30px;
    height: 30px;
    margin-bottom: -0.3rem;
  }
`

function Navbar(props) {
    return (
        <NavbarContainer>
          <SideBar pageWrapId={"page-wrap"} 
                navbarState={props.navbarState} 
                handleNavbar={props.handleNavbar} />
          <NavWrap>
            <Title href="/"><span>Me &amp;</span> Bobby McGee<NavBallImg src={Ball} alt='bouncing ball'/></Title>
            <NavLinks>
            <Link to="/about/" activeStyle={{ borderBottom: "3px solid #d6756c" }}>About</Link>
            <Link to="/tour/" activeStyle={{ borderBottom: "3px solid #d6756c" }}>Tour</Link>
            <Link to="/book/" activeStyle={{ borderBottom: "3px solid #d6756c" }}>Order the Book</Link>
            <Link to="/contact/" activeStyle={{ borderBottom: "3px solid #d6756c" }}>Contact</Link>
            </NavLinks> 
          </NavWrap>
        </NavbarContainer>
    )
}

export default Navbar